<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Audit</cll-dialog-title>
        <cll-dialog-subtitle>{{ eventSubtitle(entry.event) }}</cll-dialog-subtitle>
    </cll-dialog-header>

    <div class="audit-sections">
        <div class="audit-grid-2">
            <div class="dialog-read-only-field-container">
                <span class="dialog-read-only-title">Log</span>
                <div>
                    <cll-badge colour="variant">MODEL</cll-badge>
                </div>
            </div>
            <div class="dialog-read-only-field-container">
                <span class="dialog-read-only-title">Event</span>
                <div>
                    <cll-badge [colour]="eventBadgeColour(entry.event)">
                        <cll-icon cllBadgeIcon type="outlined">{{ eventIcon(entry.event) }}</cll-icon>
                        {{ eventLabel(entry.event) }}
                    </cll-badge>
                </div>
            </div>
        </div>

        <div class="dialog-read-only-field-container">
            <span class="dialog-read-only-title">Subject</span>
            <div class="audit-inline-row">
                <cll-badge colour="variant">CLIENT</cll-badge>
                <span class="dialog-read-only-content">{{ entry.subject_name ?? '—' }}</span>
            </div>
        </div>

        <div class="audit-grid-2">
            <div class="dialog-read-only-field-container">
                <span class="dialog-read-only-title">Caused by</span>
                <div class="audit-causer-row">
                    <cll-icon type="outlined">account_circle</cll-icon>
                    <span class="dialog-read-only-content">{{ causerDisplay() }}</span>
                </div>
            </div>
            <div class="dialog-read-only-field-container">
                <span class="dialog-read-only-title">Timestamp</span>
                <span class="dialog-read-only-content">{{ entry.created_at | appDate: 'longDateTime' }}</span>
            </div>
        </div>

        <div class="audit-grid-2">
            <div class="dialog-read-only-field-container">
                <span class="dialog-read-only-title">IP Address</span>
                <span class="dialog-read-only-content">{{ entry.ip_address ?? '—' }}</span>
            </div>
            <div class="dialog-read-only-field-container">
                <span class="dialog-read-only-title">User Agent</span>
                <span class="dialog-read-only-content">{{ entry.user_agent ?? '—' }}</span>
            </div>
        </div>

        <span class="dialog-divider-top"></span>

        <div class="dialog-read-only-field-container">
            <span class="dialog-read-only-title">Properties</span>
            <button class="audit-properties-toggle" (click)="toggleProperties()">
                Show Properties
                <cll-icon type="outlined" [size]="16">
                    {{ showProperties() ? 'expand_less' : 'expand_more' }}
                </cll-icon>
            </button>
            @if (showProperties()) {
                <div class="audit-properties-list">
                    @for (field of changedFields(); track field.key) {
                        <div class="dialog-read-only-field-container">
                            <span class="dialog-read-only-title">{{ field.label }}</span>
                            <span class="dialog-read-only-content audit-dialog-change">
                                <span class="audit-dialog-old">{{ field.oldValue }}</span>
                                <cll-icon type="outlined" [size]="16">arrow_forward</cll-icon>
                                <span class="audit-dialog-new">{{ field.newValue }}</span>
                            </span>
                        </div>
                    } @empty {
                        <span class="dialog-read-only-content">No changes recorded.</span>
                    }
                </div>
            }
        </div>

        <span class="dialog-divider-top"></span>

        <div class="dialog-read-only-field-container">
            <span class="dialog-read-only-title">ID</span>
            <span class="dialog-read-only-content">{{ entry.id }}</span>
        </div>
    </div>

    <span class="dialog-divider"></span>

    <cll-dialog-footer>
        <button cll-button
                colour="variant"
                cllDialogClose>
            Close
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
